export default {
  methods: {
    timeAgo (timestamp) {
      let divisor = 1
      let intVal = Math.floor((new Date().getTime() - timestamp) / 1000)
      let stringVal = 'second'
      if (intVal <= 60) {
        /* NoOp */
      } else if (intVal < 3600) {
        divisor = 60
        stringVal = 'minute'
      } else {
        divisor = 3600
        stringVal = 'hour'
      }
      let finalInt = Math.floor(intVal / divisor)
      return `${finalInt} ${stringVal + (finalInt > 1 ? 's' : '')} ago`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Time.js